import { ApolloClient } from "apollo-client";
import { createUploadLink } from "apollo-upload-client";
import { InMemoryCache } from "apollo-cache-inmemory";

export const HTTP_ENDPOINT: string = "https://ci04.ci.xist4c.de/graphqlapi/";

export const client = new ApolloClient({
  link: createUploadLink({
    uri: HTTP_ENDPOINT
  }),
  cache: new InMemoryCache({ addTypename: false })
});
